(function ($) {
	const $interactiveMap = $('.interactive-map:not(.interactive-map--in-lightbox)');

	if (!$interactiveMap.length) {
		return;
	}

	const $lightbox = $('.interactive-map-lightbox');
	const $lightboxOverlay = $('.interactive-map-lightbox-overlay');
	const $lightboxContent = $lightbox.find('.interactive-map-lightbox__content');
	const $lightboxNav = $lightbox.find('.interactive-map-lightbox__nav');

	const $parentContent = $('.js-parent-page-content');
	const $closeLightbox = $('.js-close-lightbox');
	const $lightboxLinks = $('.js-im-ajax-link');

	let lightboxIsOpen = false;

	init();

	function init() {
		if (!$lightbox.is('[aria-hidden="true"]')) {
			// make sure the lightbox is set as opened and disable body scroll
			openLightbox();
			checkForJSHeading();
			// alignMapToShowCurrentItem();
		}

		$closeLightbox.on('click', closeLightbox);
		$lightboxLinks.on('click', loadLightboxContent);
		$lightboxNav.on('click', 'a.js-im-ajax-link', loadLightboxContent);
		$lightboxLinks.on('mouseover', highlightSameLink);
		$lightboxLinks.on('mouseout', unhighlightSameLink);
		$lightboxLinks.on('focus', highlightSameLink);
		$lightboxLinks.on('blur', unhighlightSameLink);
	}

	function openLightbox() {
		lightboxIsOpen = true;
		$lightbox.attr('aria-hidden', 'false');
		$lightboxOverlay.attr('aria-hidden', 'false');
		$parentContent.attr('aria-hidden', 'true');
		bodyScrollLock.disableBodyScroll($lightboxContent[0]);
		$(document).on('keydown', closeOnBodyESC);
	}

	function closeLightbox(e) {
		e.preventDefault();

		lightboxIsOpen = false;
		$lightbox.attr('aria-hidden', 'true');
		$lightboxOverlay.attr('aria-hidden', 'true');
		$parentContent.attr('aria-hidden', 'false');
		bodyScrollLock.enableBodyScroll($lightboxContent[0]);

		$(document).off('keydown', closeOnBodyESC);

		if (itemToComeBackTo) {
			itemToComeBackTo.focus();
		}

		// get the first <a> which has the current url as href
		const $currentLink = $interactiveMap.find(`a[href="${window.location.href}"]`).first();

		if ($currentLink.length) {
			// get the url from its closest .interactive-map data attribute data-base-url
			const url = $currentLink.closest('.interactive-map').attr('data-base-url');
			// update the url with the base url
			history.pushState({}, '', url);
		}
	}

	let itemToComeBackTo;
	let contentScrollY = 0;
	async function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}
	async function loadLightboxContent(e) {
		e.preventDefault();

		$lightboxContent.fadeOut(200);

		// if link is an anchor link load the content of the target
		const $this = $(this);

		itemToComeBackTo = $this;

		// if the target starts with a hash, it's an anchor link
		if ($this.attr('href').startsWith('#')) {
			const $target = $($this.attr('href'));
			$lightboxContent.html($target.html());
			openLightbox();
			$lightboxContent.fadeIn(200);
			$lightboxNav.hide();
			return;
		}
		// otherwise load the content via ajax
		const url = $this.attr('href');

		const response = await fetch(url);
		const html = await response.text();

		// we only want the html inside the .interactive-map-lightbox__content
		const $html = $(html);
		const $content = $html.find('.interactive-map-lightbox__content');
		const $nav = $html.find('.interactive-map-lightbox__nav');

		$lightboxNav.eq(0).html($nav.eq(0).html());
		$lightboxNav.eq(1).html($nav.eq(1).html());
		$lightboxContent.html($content.html());

		// setTimeout(alignMapToShowCurrentItem, 10);

		// update the url with the actual link
		history.pushState({}, '', url);

		if (!lightboxIsOpen) {
			openLightbox();
			$lightboxNav.fadeIn(0);
			$lightboxContent.fadeIn(0);
		} else {
			$lightboxNav.fadeIn(200);
			$lightboxContent.fadeIn(200);
		}

		// scroll the content to the top
		$lightboxContent.scrollTop(0);

		// check if .js-transition-heading in the content
		// if so, animate it
		// await sleep(1000);
		checkForJSHeading();
	}

	function checkForJSHeading() {
		const $transitionHeading = $lightboxContent.find('.js-transition-heading');
		if ($transitionHeading.length) {
			$lightboxContent.on('scroll', animateJSHeading);
			initAnimateJSHeading($transitionHeading);
		} else {
			$lightboxContent.off('scroll', animateJSHeading);
		}
	}

	function initAnimateJSHeading($items) {
		$items.each(function () {
			const $this = $(this);
			const $target = $this.attr('data-target');

			if (!$target) {
				return;
			}

			const $targetElement = $('#' + $target);

			if (!$targetElement.length) {
				return;
			}

			const originalOffset = $this.offset();
			// clone element and add it after the original
			const $clone = $this.clone();
			$clone.addClass('js-transition-heading--clone');
			$clone.css({ margin: 0, position: 'absolute' });

			// place the clone right on top of the original
			$this.after($clone);

			const cloneOffset = $clone.offset();
			// place the clone over the original
			$clone.css({
				marginTop: originalOffset.top - cloneOffset.top,
				marginLeft: originalOffset.left - cloneOffset.left,
			});

			$clone.data('originalOffset', originalOffset);
			$clone.data('targetElement', $targetElement);
			$clone.data('original-font-size', parseInt($this.css('font-size')));
			$clone.data('final-font-size', parseInt($targetElement.css('font-size')));
			$clone.data('original-y', $clone.offset().top);
			$clone.data('final-y', originalOffset.top - $targetElement.offset().top);
			$clone.data('final-x', $targetElement.offset().left - cloneOffset.left);

			// $clone.css({ color: 'red' });
			$targetElement.css({
				opacity: 0,
				visibility: 'hidden',
			});

			$this.css({
				opacity: 0,
				visibility: 'hidden',
			});
		});
	}

	function animateJSHeading() {
		contentScrollY = $lightboxContent.scrollTop();
		updateJSHeading();
	}

	let lastScrollY = 0;

	function updateJSHeading() {
		if (lastScrollY === contentScrollY) {
			return;
		}

		lastScrollY = contentScrollY;

		const $items = $lightboxContent.find('.js-transition-heading--clone');
		$items.each(function () {
			// calculate % scroll this is the original
			const $this = $(this);
			const finalFontSize = $this.data('final-font-size');
			const finalY = $this.data('final-y');

			const percentage = lastScrollY / finalY;

			const fontSize =
				$this.data('original-font-size') -
				($this.data('original-font-size') - $this.data('final-font-size')) * percentage;
			const newPos = lastScrollY * 0.5;
			$this.css({
				transform: `translateY(${-Math.min(newPos, finalY)}px)`,
				fontSize: `${Math.max(fontSize, finalFontSize)}px`,
			});

			if (finalY < newPos * 1.2) {
				$this.addClass('transition-heading--clone--stuck');
			} else {
				$this.removeClass('transition-heading--clone--stuck');
			}
		});
	}

	function alignMapToShowCurrentItem() {
		const $currentItem = $lightboxContent.find('.interactive-map__tip--current-item');

		if (!$currentItem.length) {
			return;
		}

		const $map = $currentItem.closest('.interactive-map__map');
		const $container = $map.closest('.interactive-map--in-lightbox-container');
		const x = $currentItem.position().left;
		const y = $currentItem.position().top;
		const mapWidth = $map.width();
		const mapHeight = $map.height();
		const containerWidth = $container.width();
		const containerHeight = $container.height();

		const mapTallerBy = mapHeight - containerHeight;
		const mapWiderBy = mapWidth - containerWidth;

		// we need to make sure the the $currentItem is visible
		// if it's not visible we need to scroll to it but not overscroll
		// we need to make sure the item is visible in the center of the screen
		// if it's not we need to scroll to it
		if (x > containerWidth / 2) {
			let newX = x - containerWidth / 2;

			if (newX > mapWiderBy) {
				newX = mapWiderBy;
			}

			// scroll to the right
			$map.css('margin-left', `-${newX}px`);
		}

		if (y + $currentItem.height() > containerHeight) {
			// scroll to the bottom
			let newY = y - containerHeight / 2;
			if (newY > mapTallerBy) {
				newY = mapTallerBy;
			}
			$map.css('margin-top', `-${newY}px`);
		}
	}

	function closeOnBodyESC(e) {
		if (e.keyCode === 27) {
			closeLightbox(e);
		}
	}

	function highlightSameLink(e) {
		const $this = $(this);
		const href = $this.attr('href');

		// get all <a> with the same href
		const $targets = $(`a[href="${href}"]`);

		$targets.addClass('interactive-map--highlighted');
	}

	function unhighlightSameLink(e) {
		const $this = $(this);
		const href = $this.attr('href');

		// get all <a> with the same href
		const $targets = $(`a[href="${href}"]`);

		$targets.removeClass('interactive-map--highlighted');
	}
})(jQuery);
